module.exports = __webpack_public_path__ + "img/ventureManage.1ba8912e.jpg";